var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleRate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 53,
    viewBox: "0 0 45 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.286 50.6465C34.3945 53.4016 31.2374 52.9666 28.1984 51.6615C24.9823 50.3275 22.0318 50.2695 18.6387 51.6615C14.3899 53.4596 12.1475 52.9376 9.61008 50.6465C-4.78847 36.0587 -2.66409 13.8436 13.6818 13.0316C17.665 13.2346 20.4385 15.1777 22.7694 15.3517C26.251 14.6556 29.5851 12.6545 33.3028 12.9156C37.758 13.2636 41.1216 15.0037 43.3345 18.1358C34.1289 23.5591 36.3123 35.4787 44.7508 38.8139C43.069 43.1641 40.8856 47.4853 37.2565 50.6755L37.286 50.6465ZM22.4743 12.8576C22.0318 6.39022 27.3722 1.05395 33.5093 0.531921C34.365 8.0143 26.6051 13.5826 22.4743 12.8576Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleRate);
export default __webpack_public_path__ + "static/media/apple-rate.1af7f20a63f475337674ace906afb5a9.svg";
export { ForwardRef as ReactComponent };